import React, { Component } from 'react';
import { connect } from 'react-redux';

import ProjectDetails from './ProjectDetails';
import Icon from '../common/components/Icon';
import { doDeleteProjectRequest } from './projectsActions';
import { doShowDialog, doHideDialog } from '../reducers/app/dialog';

class ProjectDetailsContainer extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		if (this.props.UIState === 'blank') {
			return (
				<div className="c-project-details">
					<header className="c-project-details__header" />
					<div
						className="u-flex u-flex--col u-flex--justify-center u-flex--align-items-center"
						style={{
							height: '258px',
							color: '#C9C9C9',
							fill: '#C9C9C9',
							backgroundColor: '#FFF'
						}}
					>
						<Icon icon="left-alignment" size="xx-large" />
						<p style={{ fontSize: '18px' }}>
							Les informations de vos projets apparaitront ici
						</p>
					</div>
				</div>
			);
		}

		return (
			<ProjectDetails
				project={this.props.project}
				onClick={this.props.onClick}
				onDeleteProject={() =>
					this.props.deleteProject(this.props.project)}
			/>
		);
	}
}

function mapDispatchToProps(dispatch) {
	return {
		deleteProject: project =>
			dispatch(
				doShowDialog('CONFIRMATION_DIALOG', {
					message: `Voulez-vous supprimer le projet "${project.name}" ?`,
					confirmText: 'Supprimer',
					onConfirm: () =>
						dispatch(
							doDeleteProjectRequest(project.project_id)
						).then(dispatch(doHideDialog()))
				})
			)
	};
}

export default connect(null, mapDispatchToProps)(ProjectDetailsContainer);



// WEBPACK FOOTER //
// ./src/js/project-v2/ProjectDetailsContainer.js